module.exports = __webpack_public_path__ + "static/img/icon-vip-n.a8cf6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/icon-vip-n.png
// module id = SmAu
// module chunks = 21